"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialEngine = void 0;
const MaterialEngine_1 = require("./MaterialEngine");
Object.defineProperty(exports, "MaterialEngine", { enumerable: true, get: function () { return MaterialEngine_1.MaterialEngine; } });
//# sourceMappingURL=index.js.map